import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { SwarovskiOptikLocale } from "@swo/shared";
import { ImageAndProductProductTeaserInfo } from "./ImageAndProductProductTeaserInfo";
import { ImageAndProductProductCard } from "./ImageAndProductProductCard";
import React from "react";

import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";
import { ImageAndProductType, SwarovskiOptikLocaleFrontend } from "@swo/storefront";

export const ProductHoverCard: ReactTFC<{
  product: NonNullable<ImageAndProductType["product"]>;
  localeForNumberFormat: SwarovskiOptikLocaleFrontend;
}> = props => {
  return (
    <div css={elementWrapperStyles}>
      <ImageAndProductProductTeaserInfo product={props.product} localeForNumberFormat={props.localeForNumberFormat} />

      <ImageAndProductProductCard product={props.product} />
    </div>
  );
};

const elementWrapperStyles = css`
  position: relative;

  ${CSS_MQ.atMostMd} {
    display: grid;
    grid-template-columns: 80px auto;
    grid-column-gap: 13px;

    .two-columns & {
      margin-bottom: calc(2 * var(--m));
    }

    .mirrored & {
      margin-bottom: 0;
    }
  }

  ${CSS_MQ.atLeastLg} {
    &:hover {
      .product-teaser-info {
        span {
          visibility: visible;
          transition: 0.15s linear;
          filter: opacity(1);
        }
      }
    }

    .product-teaser-info:hover ~ .product-card {
      visibility: visible;
      transition: 0.15s linear;
      filter: opacity(1);
    }

    .product-card {
      transition: 0.15s linear;
      visibility: hidden;
      filter: opacity(0.2);
    }

    .product-card:hover {
      visibility: visible;
      transition: 0.15s linear;
      filter: opacity(1);
    }
  }
`;
